import { useState, useEffect } from "react";
import axios from "../../utils/axiosInstance";

import {
  PieChart,
  Pie,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";

const COLORS = ["#4e73df", "#1cc88a", "#36b9cc", "#f6c23e", "#e74a3b"];

const Marketing = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const fetchReport = async () => {
    try {
      setLoading(true);
      const res = await axios.get("/reports/marketing");
      setData(res.data);
    } catch (err) {
      console.error("Error loading marketing report", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReport();
  }, []);

  if (loading) return <p>Loading marketing report...</p>;
  if (!data) return null;

  return (
    <div className="report-marketing space-y-4">
      <h2 className="text-xl font-bold mb-2">Marketing Report</h2>

      {/* منابع جذب مشتری */}
      <div className="p-4 bg-white rounded shadow-sm">
        <h3 className="font-semibold mb-3">Sources of Customer Acquisition</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-4">
          <ul className="space-y-1 text-sm">
            {data.sources.map((s, index) => (
              <li key={index} className="flex justify-between">
                <span>{s._id || "Uncertain"}</span>
                <span className="font-semibold">{s.count} Customer</span>
              </li>
            ))}
          </ul>
          <ResponsiveContainer width="100%" height={200}>
            <PieChart>
              <Pie
                data={data.sources}
                dataKey="count"
                nameKey="_id"
                cx="50%"
                cy="50%"
                outerRadius={80}
                label
              >
                {data.sources.map((_, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* نرخ تبدیل و CLV */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="p-4 bg-white rounded shadow-sm text-center">
          <p className="text-gray-500 mb-1">Conversion Rate</p>
          <p className="text-2xl font-bold text-blue-600">
            {data.conversionRate}%
          </p>
        </div>

        <div className="p-4 bg-white rounded shadow-sm text-center">
          <p className="text-gray-500 mb-1">
            Average Customer Lifetime Value (CLV)
          </p>
          <p className="text-2xl font-bold text-green-600">${data.clv}</p>
        </div>
      </div>

      {/* درآمد مشتریان جدید و قدیمی */}
      <div className="p-4 bg-white rounded shadow-sm">
        <h3 className="font-semibold mb-2">Customer Revenue Breakdown</h3>
        <div className="flex justify-between">
          <div>
            <p className="text-gray-500 text-sm">New Customers</p>
            <p className="text-lg font-bold text-blue-600">
              ${data.newCustomersRevenue}
            </p>
          </div>
          <div>
            <p className="text-gray-500 text-sm">Returning Customers</p>
            <p className="text-lg font-bold text-emerald-600">
              ${data.returningCustomersRevenue}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Marketing;
